import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import { freemiumApi, freemiumKeys } from '@client/api/waterlily';
import { selectFeatureFlags } from '@client/model/selectors';

export function useFreemiumGate(clientId: string) {
  const advisorFeatureFlags = useSelector(selectFeatureFlags);
  const isFreemiumAdvisor = !!advisorFeatureFlags.freemiumAdvisor;

  const { data, isLoading } = useQuery({
    queryKey: freemiumKeys.planningUnlock(clientId),
    queryFn: () => freemiumApi.getPlanningUnlock(clientId),
    enabled: isFreemiumAdvisor && !!clientId,
  });

  const isUnlocked = data?.isUnlocked ?? false;
  const handoffPending = data?.handoffPending ?? false;

  return {
    isFreemiumAdvisor,
    isUnlocked,
    handoffPending,
    isGated: isFreemiumAdvisor && !isUnlocked,
    isLoading: isFreemiumAdvisor && isLoading,
  };
}
